import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch } from "react-redux";
import { updateOrderStatus } from "../../redux/action/orderAction";
import { pipGetTransictionId } from "../../utils/pip";

function OrderCancel() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    manageStatus();
  }, []);

  const manageStatus = () => {
    const data = {
      status: 2,
      transaction_id: pipGetTransictionId(),
    };
    dispatch(updateOrderStatus({ payload: data }));
  };
  return (
    <>
      <section className="we-help-section  ">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mx-auto">
              <div className="ct_cancle_order_box">
                <div className="ct_cancle_icon1">
                  <i class="fa-solid fa-xmark"></i>
                </div>
                <div className="ct_cancle_order_info">
                  <h3>Order Cancelled!</h3>
                  <p>Your order has been cancelled</p>

                  <div className="mt-4">
                    <a
                      className="btn btn-primary btn-checkout"
                      onClick={() => navigate(`${pageRoutes.home}/`)}
                    >
                      GO TO HOMEPAGE
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OrderCancel;
